import React, { ReactElement } from "react";
import Toggle from "../toggle";
import { ToggleGroup } from "../toggle/toggle-group";
import { ToggleFilterProps } from "./filter.types";

const ToggleFilterInput = ({
  toggleOptions,
  ...rest
}: ToggleFilterProps): ReactElement => {
  return (
    <ToggleGroup {...rest}>
      {toggleOptions.map((option) => (
        <Toggle key={option.value} {...option} />
      ))}
    </ToggleGroup>
  );
};

export default ToggleFilterInput;
